import Handsontable from 'handsontable'
import { cn } from '@global/utils/tailwind'
import { TranslationStatus } from '@taxonomy-translation/types'
import { editSVG } from './components'
import { TableDataChild } from '../../useTableData'

// TODO: Check how best to reuse
function openDropdown(options, _, cell, currentValue, onSelect) {
  closeAllDropdowns()

  // Empty state
  const emptyStateWrapper = document.createElement('div')
  emptyStateWrapper.className = 'text-center'
  const noDataSpan = document.createElement('span')
  noDataSpan.textContent = 'No options'
  noDataSpan.className = 'w-full'

  emptyStateWrapper.appendChild(noDataSpan)

  const dropdown = document.createElement('div')
  dropdown.className = cn(
    'absolute bg-white w-[216px] max-h-[200px] overflow-auto border border-[##ccc] z-[10]',
    'custom-dropdown',
  )

  options.forEach(option => {
    const item = document.createElement('div')
    item.textContent = option.label
    item.style.padding = '6px 12px'
    item.style.cursor = 'pointer'
    if (option.label === currentValue) {
      item.style.background = '#f0f0f0'
    }

    item.addEventListener('click', () => {
      onSelect(option.label)
      cleanup()
    })

    dropdown.appendChild(item)
  })

  if (options.length === 0) {
    dropdown.appendChild(emptyStateWrapper)
  }

  document.body.appendChild(dropdown)

  // TODO: Add table coordinate tracking to change dropdown position
  function updatePosition() {
    const rect = cell.getBoundingClientRect()
    dropdown.style.top = `${rect.bottom + window.scrollY}px`
    dropdown.style.left = `${rect.left + window.scrollX}px`
  }

  function cleanup() {
    dropdown.remove()
    document.removeEventListener('click', onClickOutside)
  }

  function onClickOutside(e) {
    if (!dropdown.contains(e.target)) {
      cleanup()
    }
  }

  updatePosition()

  setTimeout(() => {
    document.addEventListener('click', onClickOutside, { once: true })
  }, 0)
}

function closeAllDropdowns() {
  document.querySelectorAll('.custom-dropdown').forEach(el => {
    el.remove()
  })
}

export function translatedListValueColumnRenderer(
  instance: Handsontable,
  TD: HTMLTableCellElement,
  row: number,
  col: number,
  prop: string | number,
  value: string,
  cellProperties: Handsontable.CellProperties,
) {
  Handsontable.renderers.TextRenderer(instance, TD, row, col, prop, value, cellProperties)
  const { index, status, children_list_options, parent_status } = instance.getSourceDataAtRow(
    row,
  ) as TableDataChild

  if (index === undefined) {
    return TD
  }

  TD.innerHTML = ''
  TD.style.position = 'relative'

  const container = document.createElement('div')
  container.className = 'flex flex-row items-center justify-between px-3 relative h-[20px]'

  const valueWrapper = document.createElement('div')
  valueWrapper.className = cn(
    status !== TranslationStatus.Reviewed && 'bg-[hsla(59,100%,64%,0.15)]',
    'w-full h-full flex items-center',
  )

  const valueText = document.createElement('span')
  valueText.textContent = value || ''
  valueText.className = 'flex-grow'

  const icon = document.createElement('span')
  icon.className = 'flex-shrink-0 cursor-pointer ml-2 inline-flex h-3 w-3 hover:text-[red]'
  icon.innerHTML = editSVG

  if (parent_status === TranslationStatus.Reviewed) {
    cellProperties.readOnly = false
    icon.addEventListener('click', e => {
      e.stopPropagation()

      openDropdown(children_list_options, instance, TD, value, newValue => {
        instance.setDataAtCell(row, col, newValue)
      })
    })
  }

  valueWrapper.appendChild(valueText)
  valueWrapper.appendChild(icon)
  container.appendChild(valueWrapper)

  TD.appendChild(container)

  return TD
}
